import { DISPLAY_DATETIME_FORMAT } from '@msaf/core-common'
import { Card, ContentContainer, Heading, LoadingIndicator } from '@msaf/core-react'
import useAdvancedSearch from '../../../../hooks/use-advanced-search'
import { useWellId } from '../../../../hooks/use-well-id'
import { AdvancedSearchTable } from '../../../aoraki/generic-search-react/src'

export default function HistorySearch() {
  const wellId = useWellId()

  const { searchTypeKey, searchTemplate, userPermissions, requestOptions } = useAdvancedSearch({
    searchTypeKey: 'search-well-audit',
  })

  if (!(searchTemplate && 'authToken' in requestOptions && requestOptions.authToken)) {
    // TODO: Skeleton loading state
    return (
      <ContentContainer>
        <LoadingIndicator>Loading&hellip;</LoadingIndicator>
      </ContentContainer>
    )
  }

  return (
    <ContentContainer>
      <Heading level={1}>History</Heading>
      <Card isFullWidth>
        <AdvancedSearchTable
          searchTypeKey={searchTypeKey}
          requestOptions={{
            ...requestOptions,
            urlPrefix: `${requestOptions.urlPrefix}/generic-search`,
          }}
          dateFormat={DISPLAY_DATETIME_FORMAT}
          searchTemplate={searchTemplate}
          pageSize={10}
          currentUserPermissions={userPermissions}
          filterBy={{
            booleanOperator: 'AND',
            filters: [
              {
                filterKey: 'wellId',
                filterOperator: '=',
                filterValue: wellId,
              },
            ],
          }}
          isTabbedContent={false}
          isShowResultsOnMap={false}
          isShowResultsCard={false}
          defaultSortBy={{
            orderColumn: 'formattedDate',
            orderDirection: 'desc',
          }}
        />
      </Card>
    </ContentContainer>
  )
}
